/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $stateParams,
  $filter,
  $timeout,
  $mdDateLocale,
  eventService,
  helperService,
  webpage,
  uiService,
  filtersService,
  jobService,
  jobsService,
  jobTypesService,
  JobProgress,
  jobsProgressViewService,
  actionService,
  accountsService,
  contactsService,
  workflowsService,
  ticketsService,
  ACCOUNT,
  CONTACT,
  TICKET
) => {
  $scope.Model = {
    availableJobs: [],
    availableAccounts: [],
    availableJobTypes: [],
    availableJobProgresses: angular.copy(JobProgress.available()),
    availableContacts: [],
    availableWorkflows: [],
    availableTickets: [],
    availableFilters: [],
    jobsList: null,
    hasSelection: false,
    filters: {
      idFilter: null,
      appliedName: null,
      isApplied: false,
      isReady: false
    },
    filtersIsReady: false,
    isFilterApplied: false,
    filterApplied: null,
    canNotJobAdd: false,
    isProgressView: true,
    isReady: false
  };

  /*
   * Set webpage Title
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  /*
   * Methods
   * --------------------------------------------------------------------------------
   */
  $scope.getProgressViewHeight = () =>
    jobsProgressViewService.getProgressViewHeight($scope.Model.availableJobProgresses);

  $scope.progressViewHasChanges = () => {
    jobsService.clearCache();
  };

  $scope.openListView = () => {
    $state.transitionTo('tasks');
  };

  const loadJobTypes = () =>
    jobTypesService.getAvailable({ isActive: true }).then((jobTypes) => {
      $scope.Model.availableJobTypes = jobTypes;
    });

  const loadAccounts = () =>
    accountsService
      .getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.LIST })
      .then((accounts) => {
        $scope.Model.availableAccounts = accounts;
      });

  const loadWorkflows = () =>
    workflowsService.getAvailable({ isActive: true }).then((workflows) => {
      $scope.Model.availableWorkflows = workflows;
    });

  const loadFilters = () =>
    filtersService.getAvailable({ type: 'job', isActive: true }).then((filters) => {
      $scope.Model.availableFilters = filters;
    });

  const loadTickets = (idTickets) => {
    const deferred = $q.defer();
    ticketsService
      .getSpecific({ idTickets, isActive: true, fields: TICKET.FIELDS.BOARD })
      .then((tickets) => {
        $scope.Model.availableTickets = tickets;
        deferred.resolve(tickets);
      });
    return deferred.promise;
  };

  const loadContacts = (idContacts) => {
    const deferred = $q.defer();
    contactsService
      .getSpecific({ idContacts, isActive: true, fields: CONTACT.FIELDS.WTF_LIST })
      .then((contacts) => {
        $scope.Model.availableContacts = contacts;
        deferred.resolve(contacts);
      });
    return deferred.promise;
  };

  const loadJobs = (idFilter) => {
    jobsService.getAvailable({ isActive: true, idFilter }).then((jobs) => {
      webpage.pageTitle('Tasks');
      $scope.Model.showAssignedTo =
        idFilter !== null && idFilter !== '' && $rootScope.CurrentAccount.isAdministrator;
      $scope.Model.availableJobs = jobs;

      const idTickets = _.uniq(
        _.compact(_.flatten(_.map($scope.Model.availableJobs, 'idTicket')))
      );
      const idContacts = _.uniq(
        _.compact(_.flatten(_.map($scope.Model.availableJobs, 'idContact')))
      );
      if (idTickets.length || idContacts.length) {
        $q.all(loadTickets(idTickets), loadContacts(idContacts)).then(() => {
          $scope.Model.isReady = true;
        });
      } else {
        $scope.Model.isReady = true;
      }

      for (let i = 0; i < $scope.Model.availableJobProgresses.length; i += 1) {
        $scope.Model.availableJobProgresses[i].jobs = _.filter(
          $scope.Model.availableJobs,
          (job) => job.jobProgress.name === $scope.Model.availableJobProgresses[i].name
        );
        jobsProgressViewService.jobsSort($scope.Model.availableJobProgresses[i].jobs);
      }

      if ($stateParams.jobId) {
        const filteredJob = _.find(
          $scope.Model.availableJobs,
          (job) => job.id === $stateParams.jobId
        );
        if (filteredJob) {
          $timeout(() => {
            $scope.jobEdit(null, filteredJob);
          }, 1000);
        }
      }
    });
  };

  const initialize = () => {
    loadJobTypes();
    loadAccounts();
    loadWorkflows();
    loadFilters();
    loadJobs($scope.Model.filters.idFilter);
  };

  initialize();

  /*
   * Event Listeners
   * --------------------------------------------------------------------------------
   */
  $scope.jobComplete = () => {
    $scope.jobToggle($scope.Model.jobsList.getSelected());
  };

  $scope.jobIncomplete = () => {
    $scope.jobToggle($scope.Model.jobsList.getSelected());
  };

  /*
   * List Events
   * --------------------------------------------------------------------------------
   */
  $scope.jobEdit = ($event, job) => {
    eventService.jobEdit({
      event: $event !== null ? $event : null,
      job,
      isJob: true,
      showAccounts: true,
      showTicket: true,
      isTasksPage: true,
      stage: null,
      jobTypes: $scope.Model.availableJobTypes,
      accounts: $scope.Model.availableAccounts,
      workflow: null,
      ticket: null
    });
  };

  $scope.jobEdited = (jobEdited) => {
    jobsService.clearCache();
    const job = jobEdited;
    const progressLen = $scope.Model.availableJobProgresses.length;
    let progressSelectedJob = null;

    if (job.isNew === true) {
      delete job.isNew;
      const idTickets = _.uniq(
        _.compact(_.flatten(_.map($scope.Model.availableJobs, 'idTicket')))
      );
      if (job.idTicket) {
        idTickets.push(job.idTicket);
      }
      const idContacts = _.uniq(
        _.compact(_.flatten(_.map($scope.Model.availableJobs, 'idContact')))
      );
      if (job.idTicket) {
        idTickets.push(job.idTicket);
      }
      if (job.idContact) {
        idContacts.push(job.idContact);
      }
      if (idTickets.length || idContacts.length) {
        $q.all(loadTickets(idTickets), loadContacts(idContacts)).then(() => {
          $scope.Model.availableJobProgresses[job.isCompleted ? 2 : 0].jobs.push(job);
        });
      } else {
        $scope.Model.availableJobProgresses[job.isCompleted ? 2 : 0].jobs.push(job);
      }
    } else {
      for (let i = 0; i < progressLen; i += 1) {
        progressSelectedJob = _.find($scope.Model.availableJobProgresses[i].jobs, {
          id: job.id
        });
        if (progressSelectedJob) {
          const idx = helperService.findIndexById(
            $scope.Model.availableJobProgresses[i].jobs,
            progressSelectedJob.id
          );
          if (idx > -1) {
            $scope.Model.availableJobProgresses[i].jobs.splice(idx, 1);
          }
          $scope.Model.availableJobProgresses[job.isCompleted ? 2 : 1].jobs.push(job);
          jobsProgressViewService.jobsSort(
            $scope.Model.availableJobProgresses[job.isCompleted ? 2 : 1].jobs
          );
          break;
        }
      }
    }
  };

  $scope.jobToggle = (jobs) => {
    jobsService.clearCache();
    const selectedJobs = jobs instanceof Array ? jobs : [jobs];
    const len = selectedJobs.length;
    const progressLen = $scope.Model.availableJobProgresses.length;
    let idx = -1;
    for (let i = 0; i < len; i += 1) {
      selectedJobs[i].isCompleted = !selectedJobs[i].isCompleted;
      jobService.updateJob({
        id: selectedJobs[i].id,
        isCompleted: selectedJobs[i].isCompleted,
        jobProgress: selectedJobs[i].isCompleted
          ? JobProgress.available()[2]
          : JobProgress.available()[0]
      });
      for (let j = 0; j < progressLen; j += 1) {
        idx = helperService.findIndexById(
          $scope.Model.availableJobProgresses[j].jobs,
          selectedJobs[i]
        );
        if (idx > -1) {
          $scope.Model.availableJobProgresses[j].jobs.splice(idx, 1);
          $scope.Model.availableJobProgresses[selectedJobs[i].isCompleted ? 2 : 0].jobs.push(
            selectedJobs[i]
          );
          jobsProgressViewService.jobsSort(
            $scope.Model.availableJobProgresses[selectedJobs[i].isCompleted ? 2 : 0].jobs
          );
          break;
        }
      }
      if (idx > -1) {
        $scope.Model.availableJobProgresses[2].jobs.splice(idx, 1);
      }
    }
  };

  $scope.filterOpen = ($event) => {
    $event.stopPropagation();
    $scope.Model.filters.isReady = true;
  };

  $scope.filtersApplied = (idFilter, filterName) => {
    jobsService.clearCache();
    filtersService.clearCache();
    $scope.Model.isReady = false;
    $scope.Model.filters.isApplied = idFilter !== null;
    $scope.Model.filters.appliedName = filterName;
    loadJobs(idFilter);
    loadFilters();
    $timeout(() => {
      $scope.Model.filters.isReady = false;
    }, 500);
  };

  $scope.filtersClosed = () => {
    $timeout(() => {
      $scope.Model.filters.isReady = false;
    }, 500);
  };

  /*
   * Job Movement Options
   * --------------------------------------------------------------------------------
   */
  $scope.jobSortingOptions = {
    placeholder: 'job-drag-place-holder',
    connectWith: 'board stage main',
    cursor: 'move',
    opacity: 0.65,
    start(e, ui) {
      ui.item.show().addClass('ghost');
    },
    helper(event, element) {
      return $(element).clone().addClass('dragging');
    },
    update(event, ui) {
      const id = $(ui.item.sortable.droptarget[0]).attr('id');
      if (
        (!ui.item.sortable.received &&
          ui.item.sortable.source[0] === ui.item.sortable.droptarget[0]) ||
        (id === 'done' && !ui.item.sortable.model.canBeCompleted())
      ) {
        ui.item.sortable.cancel();
        if (id === 'done' && !ui.item.sortable.model.canBeCompleted()) {
          uiService.toast({
            text: {
              p1: 'Not all sub-tasks',
              p2: 'have been',
              p3: 'completed'
            },
            warn: true
          });
        }
      }
    },
    stop(e, ui) {
      ui.item.show().removeClass('ghost');
      jobsProgressViewService.jobMove(ui, $scope.Model.availableJobProgresses).then((data) => {
        if (data) {
          $scope.progressViewHasChanges();
        } else {
          uiService.toast({
            text: {
              p1: 'Not all sub-tasks',
              p2: 'have been',
              p3: 'completed'
            },
            warn: true
          });
        }
      });
    }
  };
};
